module.exports = __webpack_public_path__ + "img/buy.df53cf1f.webp";